import { render, staticRenderFns } from "./MyDonations.vue?vue&type=template&id=a53d05d2&scoped=true&"
import script from "./MyDonations.vue?vue&type=script&lang=js&"
export * from "./MyDonations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53d05d2",
  null
  
)

export default component.exports